export default prefix => actionName => `${prefix}/${actionName}`;
